<template>
    <div>
        <div>
            <b-navbar
                fixed="top"
                :toggleable="navbarSize"
                type="light"
                variant="light"
            >
                <b-navbar-brand
                    ><router-link to="/dashboard" exact>
                        {{ $t('nedGlobeDashboardTitle') }}</router-link
                    ></b-navbar-brand
                >
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                <b-collapse id="nav-collapse" v-model="visible" is-nav>
                    <b-navbar-nav>
                        <!-- Navbar dropdowns -->
                        <b-nav-item-dropdown left v-if="hasNedGlobeServices">
                            <template v-slot:button-content>
                                <span class="fa fa-globe-americas"></span>
                                {{ $t('menuItemDataManagement') }}
                            </template>
                            <!-- NedGlobe Services tabellen -->
                            <b-dropdown-item to="/dashboard/tables" exact>
                                <span class="fa fa-list-alt"></span>
                                {{ $t('nedglobeServices.tables.menuitem') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Data importeren -->
                            <b-dropdown-item :to="{ name: 'dataImport' }" exact>
                                <span class="fa fa-file-import"></span>
                                {{ $t('menuItemDataImport') }}
                            </b-dropdown-item>
                            <!-- FME import results -->
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item
                                :to="{ name: 'fmeImportResults' }"
                                exact
                            >
                                <span class="fa fa-list-alt"></span>
                                {{ $t('menuItemFmeImportResults') }}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                        <b-nav-item-dropdown left>
                            <template v-slot:button-content>
                                <span class="fa fa-globe-americas"></span>
                                {{ $t('menuItemBase') }}
                            </template>
                            <!-- OWS -->
                            <b-dropdown-item to="/dashboard/ows" exact>
                                <span class="fa fa-cloud-download-alt"></span>
                                {{ $t('menuItemOwsService') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Themalagen -->
                            <b-dropdown-item to="/dashboard/themelayers" exact
                                ><span class="fa fa-layer-group"></span>
                                {{ $t('menuItemThemeLayers') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Themegroups -->
                            <b-dropdown-item
                                :to="{ name: 'themegroupOverview' }"
                                exact
                                ><span class="fa fa-th-large"></span>
                                {{ $t('menuItemThemeGroups') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Thema's -->
                            <b-dropdown-item to="/dashboard/themes" exact
                                ><span class="fa fa-list-ul"></span>
                                {{ $t('menuItemThemes') }}
                            </b-dropdown-item>
                            <div v-if="getCheckForFeatureToggle('60002')">
                                <b-dropdown-divider></b-dropdown-divider>
                                <!-- 3D Layers -->
                                <b-dropdown-item to="/dashboard/layers3D" exact
                                    ><span class="fa fa-cube"></span>
                                    {{ $t('menuItemLayers3D') }}
                                </b-dropdown-item>
                            </div>
                            <div v-if="hasNedGlobeServices">
                                <b-dropdown-divider></b-dropdown-divider>
                                <!-- Table results -->
                                <b-dropdown-item
                                    :to="{ name: 'tableresultsOverview' }"
                                    exact
                                    ><span class="fa fa-th-list"></span>
                                    {{ $t('menuItemTableResults') }}
                                </b-dropdown-item>
                            </div>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Domeinen -->
                            <b-dropdown-item to="/dashboard/domains" exact>
                                <span class="fa fa-list-alt"></span>
                                {{ $t('menuItemDomains') }}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                        <!-- These menus only visible if organisation has a web license -->
                        <b-nav-item-dropdown v-if="hasWebLicense" left>
                            <template v-slot:button-content>
                                <span class="fa fa-th"></span>
                                {{ $t('menuItemWebThemeCards') }}
                            </template>
                            <!-- Overzicht Web themakaarten-->
                            <b-dropdown-item to="/dashboard/webthemes" exact
                                ><span class="fa fa-list-alt"></span>
                                {{ $t('menuItemOverview') }}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                        <!-- These menus only visible if organisation has a mobile or web license -->
                        <b-nav-item-dropdown
                            v-if="hasMobileLicense || hasWebLicense"
                            left
                        >
                            <template v-slot:button-content>
                                <span class="fa fa-list-alt"></span>
                                {{ $t('menuItemStorageLayers') }}
                            </template>
                            <!-- Overzicht Opslaglagen -->
                            <b-dropdown-item to="/dashboard/feedbacks" exact>
                                <span class="fa fa-list-alt"></span>
                                {{ $t('menuItemOverview') }}
                            </b-dropdown-item>
                            <b-dropdown-divider
                                v-if="hasWebLicense"
                            ></b-dropdown-divider>
                            <b-dropdown-item
                                v-if="hasWebLicense"
                                to="/dashboard/feedbackCategory"
                                exact
                            >
                                <span class="fa fa-list-alt"></span>
                                {{ $t('menuItemFeedbackCategories') }}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                        <!-- Profielen -->
                        <b-nav-item-dropdown
                            v-if="hasMobileLicense || hasWebLicense"
                            left
                        >
                            <template v-slot:button-content>
                                <span class="fa fa-user"></span>
                                {{ $t('menuItemAuthorization') }}
                            </template>
                            <!-- Overzicht Profielen -->
                            <div v-if="hasMobileLicense">
                                <b-dropdown-item to="/dashboard/profiles" exact>
                                    <span class="fa fa-user"></span>
                                    {{ $t('menuItemProfiles') }}
                                </b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                            </div>
                            <!-- Overzicht GebruikersGroepen -->
                            <div v-if="hasMobileLicense">
                                <b-dropdown-item
                                    to="/dashboard/userGroups"
                                    exact
                                >
                                    <span class="fa fa-users"></span>
                                    {{ $t('menuItemUserGroups') }}
                                </b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                            </div>
                            <!-- Overzicht Gebruikers -->
                            <b-dropdown-item to="/dashboard/users" exact>
                                <span class="fa fa-user"></span>
                                {{ $t('menuItemUsers') }}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                        <!-- System group -->
                        <b-nav-item-dropdown left>
                            <template v-slot:button-content>
                                <span class="fa fa-cog"></span>
                                {{ $t('menuItemSystem') }}
                            </template>
                            <!-- Controle -->
                            <b-dropdown-item to="/dashboard/controle" exact>
                                <span class="fa fa-check"></span>
                                {{ $t('menuItemCheck') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Instellingen -->
                            <b-dropdown-item to="/dashboard/settings" exact>
                                <span class="fa fa-cog"></span>
                                {{ $t('menuItemSettings') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- API-Instellingen -->
                            <template
                                v-if="
                                    isAdmin &&
                                    hasMobileLicense &&
                                    hasAnyApiLicense
                                "
                            >
                                <b-dropdown-item
                                    to="/dashboard/OrganizationApisettingsOverview"
                                    exact
                                >
                                    <span class="fas fa-users-cog"></span>
                                    {{
                                        $t(
                                            'apiSettings.titleOrganizationApiSettings'
                                        )
                                    }}
                                </b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                            </template>
                            <!-- NedBrowser -->
                            <template v-if="isSuper">
                                <b-dropdown-item
                                    to="/dashboard/NedBrowser"
                                    exact
                                >
                                    <span class="fa fa-file-import"></span>
                                    {{ $t('menuItemNedBrowser') }}
                                </b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                            </template>
                            <!-- Links -->
                            <template v-if="isAdmin && hasMobileLicense">
                                <b-dropdown-item
                                    to="/dashboard/UrlConnectionsOverview"
                                    exact
                                >
                                    <span class="fa fa-link"></span>
                                    {{ $t('menuItemLinks') }}
                                </b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                            </template>
                            <!-- Bitmaps -->
                            <b-dropdown-item to="/dashboard/bitmaps" exact>
                                <span class="fa fa-image"></span>
                                {{ $t('menuItemBitmaps') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Style patterns -->
                            <template v-if="isAdmin">
                                <b-dropdown-item
                                    to="/dashboard/PolygonPatterns/77c901a9-278a-4537-b8f2-16818d43d7b5"
                                >
                                    <span class="fa fa-image"></span>
                                    {{
                                        $t(
                                            'styling.patterns.titlePolygonPatterns'
                                        )
                                    }}
                                </b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                            </template>
                            <!-- Print -->
                            <template v-if="isSuper">
                                <b-dropdown-item to="/dashboard/printing" exact>
                                    <span class="fa fa-print"></span>
                                    {{ $t('menuItemPrint') }}
                                </b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                            </template>
                            <!-- News Items -->
                            <b-dropdown-item
                                to="/dashboard/newsItems/newsitems"
                                exact
                            >
                                <span class="fa fa-file-alt"></span>
                                {{ $t('menuItemNewsItems') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- MessagesFeed -->
                            <b-dropdown-item
                                to="/dashboard/newsItems/msgfeeds"
                                exact
                            >
                                <span class="fa fa-file-alt"></span>
                                {{ $t('menuItemMessagesFeed') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Release Notes -->
                            <b-dropdown-item to="/dashboard/releaseNotes" exact>
                                <span class="fa fa-file"></span>
                                {{ $t('menuItemReleaseNotes') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Statistieken grafisch -->
                            <b-dropdown-item
                                to="/dashboard/statistics/usage"
                                exact
                            >
                                <span class="fa fa-chart-bar"></span>
                                {{ $t('menuItemUsage') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Statistics -->
                            <b-dropdown-item to="/dashboard/statistics" exact>
                                <span class="fa fa-chart-line"></span>
                                {{ $t('menuItemStatistics') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item
                                to="/dashboard/dashboardLogs"
                                exact
                            >
                                <span class="fa fa-list-alt"></span>
                                {{ $t('menuItemDashboardLogs') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item
                                to="/dashboard/dashboardAlerts"
                                exact
                            >
                                <span class="fa fa-list-alt"></span>
                                {{ $t('menuItemDashboardAlerts') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item @click="$_helpDashboard()" exact>
                                <span class="fa fa-question-circle"></span>
                                {{ $t('menuItemDashboardHelp') }}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                        <!-- Management group -->
                        <b-nav-item-dropdown v-if="isSuper" left>
                            <template v-slot:button-content>
                                <span class="fa fa-cog"></span>
                                {{ $t('menuItemManagement') }}
                            </template>
                            <!-- Main application settings -->
                            <b-dropdown-item to="/dashboard/mainSettings" exact>
                                <span class="fas fa-cog"></span>
                                {{ $t('menuItemSettings') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Url connection licenses -->
                            <b-dropdown-item
                                to="/dashboard/connectionLicenses"
                                exact
                            >
                                <span class="fab fa-confluence"></span>
                                {{ $t('urlConnectionLicenses') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Apis -->
                            <b-dropdown-item to="/dashboard/apiSettings" exact>
                                <span class="fas fa-cogs"></span>
                                {{ $t('apiSettings.title') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Organisaties -->
                            <b-dropdown-item
                                to="/dashboard/organizations"
                                exact
                            >
                                <span class="fa fa-briefcase"></span>
                                {{ $t('menuItemOrganizations') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Standaard producten-->
                            <b-dropdown-item to="/dashboard/products" exact>
                                <span class="fa fa-list-alt"></span>
                                {{ $t('product.products') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Cooperations -->
                            <b-dropdown-item to="/dashboard/cooperations" exact>
                                <span class="fa fa-handshake"></span>
                                {{ $t('menuItemCooperations') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Deleted Organisaties -->
                            <b-dropdown-item
                                to="/dashboard/functionresults"
                                exact
                            >
                                <span class="fa fa-list-alt"></span>
                                {{ $t('menuItemFunctionResults') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Style patterns -->
                            <template v-if="isSuper">
                                <b-dropdown-item
                                    to="/dashboard/PolygonPatterns/21f4a37b-bd40-4e2a-a0fe-ae98dbcf75d0"
                                    ><span class="fa fa-image"></span>
                                    {{
                                        $t(
                                            'styling.patterns.titleDefaultPolygonPatterns'
                                        )
                                    }}
                                </b-dropdown-item>
                            </template>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Webjobs -->
                            <b-dropdown-item to="/dashboard/webJobs" exact
                                ><span class="fa fa-wrench"></span>
                                {{ $t('menuItemWebJobs') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Errorlog-->
                            <b-dropdown-item to="/dashboard/errorlog" exact
                                ><span class="fa fa-exclamation-circle"></span>
                                {{ $t('menuItemErrorlog') }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <!-- Search in SearchCache -->
                            <b-dropdown-item to="/dashboard/searchInCache" exact
                                ><span class="fa fa-search"></span>
                                {{ $t('menuItemSearchInCache') }}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                    </b-navbar-nav>
                    <b-navbar-nav class="ml-auto">
                        <!-- Organization switcher for superuser -->
                        <b-form-select
                            v-if="showSuperUserSwitcher"
                            :value="userInfo.organizationId"
                            @change="$_changeOrgs($event)"
                            :options="organizationList"
                        >
                        </b-form-select>
                        <!-- Organization switcher for cooperation -->
                        <cooperation-organization-switcher
                            v-if="showAdminSwitcher"
                            :organizationId="userInfo.organizationId"
                            :organizations="cooperationOrganizationList"
                            @changed-organization="
                                onOrganizationChanged($event)
                            "
                        >
                        </cooperation-organization-switcher>
                        <!-- Username and logoff button -->
                        <b-nav-text class="px-2"
                            ><strong>{{ userName }}</strong></b-nav-text
                        >
                        <b-nav-item
                            v-if="isAuthenticated && isAuthorized"
                            @click="$_logOut"
                        >
                            <span class="fa fa-sign-out-alt"></span>
                            {{ $t('logOut') }}
                        </b-nav-item>
                    </b-navbar-nav>
                    <b-navbar-nav>
                        <b-nav-item :title="$t('labelUserVoice')">
                            <div class="icon-container">
                                <uservoice-comp :showLabel="visible" />
                            </div>
                        </b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
        </div>
    </div>
</template>

<script>
    import { setFavicon } from '../../services/utilities';
    import { AVAILABLE_LOGO_TYPE, ONLINE_HELP } from '../../constants';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import { mapState, mapActions, mapGetters } from 'vuex';
    import UserVoiceComp from '../../components/geo/panels/userVoice/userVoice.vue';
    import CooperationOrganizationSwitcher from '../../components/CooperationOrganizationSwitcher.vue';
    import i18n from '../../i18n';

    export default {
        mixins: [modalMixin],
        components: {
            'uservoice-comp': UserVoiceComp,
            'cooperation-organization-switcher': CooperationOrganizationSwitcher
        },

        data() {
            return {
                organizationList: [],
                cooperationOrganizationList: [],
                visible: false
            };
        },

        computed: {
            ...mapState(['userInfo', 'hasAnyApiLicense']),
            ...mapGetters(['getCheckForFeatureToggle']),
            hasNedGlobeServices() {
                return this.userInfo.hasNedGlobeServices;
            },
            hasMobileLicense() {
                return this.userInfo.licenses.has_mobile_license;
            },
            hasWebLicense() {
                return this.userInfo.licenses.has_web_license;
            },
            isAuthenticated() {
                return this.userInfo.isAuthenticated;
            },
            isAuthorized() {
                return this.userInfo.isAuthorized;
            },
            isSuper() {
                return this.userInfo.isSuper;
            },
            isAdmin() {
                return this.userInfo.isAdmin;
            },
            userName() {
                return this.userInfo?.userName.split('@')[0] ?? '';
            },
            showSuperUserSwitcher() {
                return this.isSuper;
            },
            showAdminSwitcher() {
                return !this.isSuper && this.cooperationOrganizationList.length > 0;
            },
            navbarSize() {
                if (this.isSuper) {
                    return 'xl'; //was xl3
                }
                if (this.showAdminSwitcher) {
                    return 'xl'; //was xl2
                }
                return 'xl'; //was xl1
            }
        },

        async created() {
            // Register a possible FT number
            if (this.$route.query.FT > 0) {
                this.$store.commit('REGISTER_FEATURE_TOGGLE', this.$route.query.FT);
            }
        },
        mounted() {
            // Only superuser can retrieve the organization-list
            this.$_getOrganizationList();
            this.$_getCooperationOrganizationList();
            // Retrieve the organization-list after organization has been removed or saved
            this.$root.$on('organisation_changed', () => {
                this.$_getOrganizationList();
                this.$_getCooperationOrganizationList();
            });
            // set language
            i18n.locale =
                this.$store.state.userInfo.organizationLanguage.toLowerCase();
        },

        methods: {
            ...mapActions(['getHasAnyApiLicense']),
            // Selected value for new organizationId is contained in the event
            $_hasFeatureToggle60002() {
                return this.$route.query.FT === '60002';
            },
            async $_changeOrgs(event) {
                if (event) {
                    const orgSelected = {
                        data: event,
                        userName: this.$store.getters.userInfo.userName
                    };
                    // switch organization
                    await this.$store
                        .dispatch('useApiData', {
                            name: 'SaveOrganizationSettings',
                            data: orgSelected
                        })
                        .then((result) => {
                            // Organization is successfully changed, update user credentials
                            this.$store.dispatch('getUserAuthentication');
                            this.showToast({
                                message:
                                    'Organisatie succesvol veranderd. U wordt doorgestuurd naar de homepage.',
                                variant: 'success',
                                autoHideDelay: 2000,
                                noCloseButton: true
                            });
                            setTimeout(() => {
                                this.$_setOrganizationFavicon();
                                this.$store.dispatch('getHasAnyApiLicense');
                                this.$_gotoHome();
                            }, 2000);
                        });
                }
            },

            async _removeUserFromCache() {
                try {
                    await this.$store.dispatch('useApiData', {
                        name: 'RemoveUserFromCache',
                        parameters: { Id: this.userInfo.userID }
                    });
                } catch (error) {
                    const data = {
                        message: this.$t(error.message),
                        variant: 'danger',
                        title: this.$t(error.title),
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                }
            },

            /**
             * Admin changed the organization within the cooperation
             */
            async onOrganizationChanged(event) {
                await this._removeUserFromCache();
                // switch organization
                const selectedOrganization = {
                    data: event.organizationId,
                    userName: this.$store.getters.userInfo.userName
                };
                this.userInfo.organizationId = event.organizationId;
                await this.$store
                    .dispatch('useApiData', {
                        name: 'SaveOrganizationSettings',
                        data: selectedOrganization
                    })
                    .then(
                        (result) => {
                            // Organization is successfully changed, update user credentials
                            this.$store.dispatch('getUserAuthentication');
                            this.showToast({
                                message: this.$t(
                                    'cooperation.switchedOrganization'
                                ),
                                variant: 'success',
                                autoHideDelay: 2000,
                                noCloseButton: true
                            });
                            setTimeout(() => {
                                this.$_setOrganizationFavicon();
                                this.$store.dispatch('getHasAnyApiLicense');
                                this.$_gotoHome();
                            }, 2000);
                        },
                        (error) => {
                            this.showToast({
                                message: this.$t(error.message),
                                variant: 'danger',
                                autoHideDelay: 5000,
                                noCloseButton: false
                            });
                        }
                    );
            },

            $_gotoHome() {
                // Redirect to home if not already there
                if (this.$router.currentRoute.fullPath !== '/dashboard') {
                    this.$router.push({ path: '/' });
                }
            },

            async $_getOrganizationList() {
                if (this.$store.getters.userInfo.isSuper) {
                    await this.$store
                        .dispatch('useApiData', {
                            name: 'GetOrganizationList'
                        })
                        .then((orgList) => {
                            this.organizationList = orgList.data?.map((item) => {
                                return { value: item.id, text: item.name };
                            });
                        });
                } else {
                    this.organizationList = [];
                }
                this.$_setOrganizationFavicon();
                this.$store.dispatch('getHasAnyApiLicense');
            },

            async $_getCooperationOrganizationList() {
                if (!this.$store.getters.userInfo.isSuper) {
                    await this.$store
                        .dispatch('useApiData', {
                            name: 'GetOrganizationList'
                        })
                        .then((result) => {
                            // the organization of the admin maybe part of a cooperation
                            const adminOrganization = result.data?.filter(
                                (item) => item.id === this.userInfo.organizationId
                            );
                            if (
                                adminOrganization.length > 0 &&
                                adminOrganization[0].cooperationId
                            ) {
                                // cooperation the admin is part of
                                const cooperationId =
                                    adminOrganization[0].cooperationId;
                                // filter organizations which are part of the cooperation
                                this.cooperationOrganizationList = result.data
                                    ?.filter(
                                        (item) =>
                                            item.cooperationId === cooperationId
                                    )
                                    .map((item) => {
                                        return { value: item.id, text: item.name };
                                    });
                            } else {
                                this.cooperationOrganizationList = [];
                            }
                        });
                }
            },

            $_logOut() {
                this.$router.push('/logout');
            },
            $_helpDashboard() {
                window.open(
                    `${ONLINE_HELP.COMMON.uri}${ONLINE_HELP.DASHBOARD.helpfile}`,
                    ONLINE_HELP.DASHBOARD.title
                );
            },
            /**
             * Sets the favicon for the selected organization
             */
            async $_setOrganizationFavicon() {
                if (this.userInfo.organizationId > 0) {
                    await this.$store
                        .dispatch('useApiData', {
                            name: 'GetImageByType',
                            parameters: { typeId: AVAILABLE_LOGO_TYPE[1].value }
                        })
                        .then((result) => {
                            if (result.data) {
                                setFavicon(result.data);
                            } else {
                                setFavicon();
                            }
                        })
                        .catch((error) => {
                            // No further action is required
                        });
                }
            }
        }
    };
</script>

<style lang="scss">
#nav-collapse {
    a.nav-link {
        &:focus,
        &:hover {
            background-color: #e9ecef;
        }
    }
}

@media (max-width: 1200px) {
    #nav-collapse {
        max-height: calc(100vh - 120px); /* 120 = header + footer */
        overflow-y: auto;
    }
}

@media (min-width: 1200px) {
    #nav-collapse .dropdown-menu {
        max-height: calc(100vh - 120px); /* 120 = header + footer */
        overflow-y: auto;
    }
}

.icon-container {
    display: contents;

    &:hover:not(.icon-container-disabled) div {
        background-color: rgba(0, 0, 0, 0.7);
    }

    .uv-container {
        .img-size {
            margin-top: 4px;
            width: 16px;
            height: 16px;
            background-size: 16px;
            mask-size: 16px;
        }

        .span-label {
            padding-left: 3px;
        }
    }
}
</style>

<style scoped lang="scss">
.dropdown-toggle > span,
.dropdown-item > span {
    padding-right: 2px;
}
</style>
